type OptionalQueryValue = string | null | undefined

export const bodyMeasurementKeys = {
  all: ['BodyMeasurement'] as const,
  list: (
    isAuthenticated: boolean,
    email: OptionalQueryValue,
    filterParams: string | undefined
  ) =>
    [...bodyMeasurementKeys.all, isAuthenticated, email, filterParams] as const
}
